'use client';

var __jsx = React.createElement;
import React, { useEffect, useState } from 'react';
import MuscleModal from '@modules/shared/components/modal';
import LoadingAnimation from '@modules/shared/animations/loading';
import { MuscleButton } from '@modules/shared/components/buttons';
import { useTranslations } from 'next-intl';
import customersManager from '@lib/data/managers/shared/customers-manager';
import AuthFormTemplate from '@modules/shared/auth-flows/templates/auth-form.template';
import APP_CONFIGURATION from '@lib/app.config';
const SuccessValidatingIdModal = _ref => {
  let {
    isOpen,
    setIsOpen,
    idType,
    idNumber,
    customerEmail,
    onErrorSendingEmail,
    dataTestId
  } = _ref;
  const t = useTranslations('Shared.Auth');
  const {
    0: isSendingEmail,
    1: setIsSendingEmail
  } = useState(true);
  useEffect(() => {
    if (isOpen) {
      sendConfirmationEmail();
    }
  }, [isOpen]);
  const sendConfirmationEmail = async () => {
    setIsSendingEmail(true);
    const sendConfirmationEmailResponse = await customersManager.sendConfirmationInstructions(idType, idNumber);
    if ('code' in sendConfirmationEmailResponse) {
      onErrorSendingEmail(sendConfirmationEmailResponse.code);
    }
    setIsSendingEmail(false);
  };
  const getHiddenEmail = () => {
    if (customerEmail) {
      const emailSplit = customerEmail.split('@');
      const emailPartToShow = emailSplit[0].substring(0, emailSplit[0].length - 4);
      return "".concat(emailPartToShow, "****@").concat(emailSplit[1]);
    }
  };
  return __jsx(MuscleModal, {
    dataTestId: dataTestId,
    openState: isOpen,
    setOpenState: setIsOpen
  }, __jsx(AuthFormTemplate, null, isSendingEmail ? __jsx(React.Fragment, null, __jsx("div", {
    className: "w-96 h-44 flex items-center justify-center"
  }, __jsx(LoadingAnimation, {
    height: 100,
    color: APP_CONFIGURATION.colors.primary_main
  }))) : __jsx(React.Fragment, null, __jsx("div", {
    className: "flex flex-col gap-8 p-2 items-center"
  }, __jsx("div", {
    className: "text-2xl text-primary-main font-bold"
  }, t('WELCOME')), __jsx("div", {
    className: "text-base text-black font-thin w-96 text-center"
  }, "".concat(t('REGISTER_VERIFICATION_SUCCESS_MSG_1'), " ").concat(getHiddenEmail(), " ").concat(t('REGISTER_VERIFICATION_SUCCESS_MSG_2'))), __jsx("div", {
    className: "text-base text-black font-thin w-96 text-center"
  }, t('REGISTER_VERIFICATION_SUCCESS_MSG_3')), __jsx(MuscleButton, {
    dataTestId: dataTestId + "-resend-button",
    variant: "solidMd",
    onClick: sendConfirmationEmail
  }, t('RESEND'))))));
};
export default SuccessValidatingIdModal;